import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../../components/context/Auth";
import {
  NewEyeIcon,
  RemoveIcon,
  SaveAsDraftIcon,
  SaveIcon,
  TestTopAddDealerIcon,
} from "../../components/icons/Icon";
import Button from "../../components/updatedComponents/Dealers/Button";
import InputTag from "../../components/updatedComponents/FormComponents/InputTag";
import VerticalDropDown2 from "../../components/updatedComponents/FormComponents/VerticalDropDown2";
import ModalWrapper from "../../components/updatedComponents/layoutWrapper/ModalWrapper";
import styles from "./PurchaseOrder.module.css";
import React, { useEffect, useRef, useState } from "react";
import fetchData from "../../APIsControll/apiControll";
import PurchaseItemList from "../../components/updatedComponents/OrderManager/PurchaseItemList";
import PurchaseNewItemList from "../../components/updatedComponents/OrderManager/PurchaseNewItemList";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import ManagerModal from "../../components/updatedComponents/Manager/ManagerModal";
import Skeleton from "../../components/updatedComponents/Skeleton/Skeleton";

const Transfer = ({ onOrderData }) => {
  const { managerId, mode, managerName } = useAuth();
  const { show } = useToast();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const orderId = searchParams.get("orderId");

  const [generalInfo, setGeneralInfo] = useState({});
  const [showItemSearch, setShowItemSearch] = useState(false);
  const [focusedItemIndex, setFocusedItemIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [warehouses, setWarehouses] = useState([]);
  const [openDD2, setOpenDD2] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [itemsdetails, setItemsdetails] = useState([
    {
      itemNo: "",
      price: "",
      product_name: "",
      thumbnail: "",
      totalQty: "",
      qty: "",
      unit: "",
      warehouse: "",
    },
  ]);

  const itemInpRefs = useRef([]);
  const quantityRefs = useRef([]);
  const scroll_wrapper_ref = useRef(null);

  useEffect(() => {
    const apiData = {
      managerId: managerId,
      voucherNo: orderId,
    };
    const getTransfer = async () => {
      try {
        setLoading(true);
        const result = await fetchData("inventory/stocktransfer", apiData);
        if (result.status === "success") {
          if (result.data.order) {
            setGeneralInfo((prevState) => ({
              ...prevState,
              // vendorName: result.data.order.vendorName
              //   ? result.data.order.vendorName
              //   : "",
              managerName: result.data.order.managerName,
              voucherNo: result.data.order.voucherNo
                ? result.data.order.voucherNo
                : "",
              voucherDate: result.data.order.voucherDate
                ? result.data.order.voucherDate
                : "",
              fromWarehouse: result.data.order.fromWarehouse
                ? result.data.order.fromWarehouse
                : "",
              toWarehouse: result.data.order.toWarehouse
                ? result.data.order.toWarehouse
                : "",
              shippingCharge: result.data.order.shippingCharge
                ? result.data.order.shippingCharge
                : "",
              manageName: result.data.order.manageName
                ? result.data.order.manageName
                : "",
              manageValue: result.data.order.manageValue
                ? result.data.order.manageValue
                : "",
              status: result.data.order.status ? result.data.order.status : "",
            }));
            setItemsdetails(result.data.order.itemsdetails);
          }
          if (result.data.warehouses) {
            setWarehouses(result.data.warehouses);
          }
        }
      } catch (error) {
        setLoading(false);
        //console.log("error ", error);
      } finally {
        setLoading(false);
      }
    };

    if (managerId) {
      getTransfer();
    }
  }, [managerId, orderId]);

  const handleTransferOrder = async (status) => {
    const apiData = {
      managerId: managerId,
      voucherNo: orderId || "",
      fromWarehouse: generalInfo.fromWarehouse,
      toWarehouse: generalInfo.toWarehouse,
      shippingCharge: generalInfo.shippingCharge || "",
      manageName: generalInfo.manageName || "",
      manageValue: generalInfo.manageValue || "",
      itemsdetails: itemsdetails.filter((item) =>
        Object.values(item).some(
          (value) => value !== "" && value !== null && value !== undefined
        )
      ),
      status: status,
    };
    try {
      setLoading2(true);
      const result = await fetchData("inventory/stocktransfervoucher", apiData);
      if (result.status === "success") {
        setLoading2(false);
        show(result.msg, "success");
        navigate(`/orders/order/transfer?orderId=${result.data.voucherNo}`);
      }
      if (result.status === "failed") {
        setLoading2(false);
        show(result.msg, "error");
      }
    } catch (error) {
      setLoading2(false);
      //console.log("Error ", error);
    }
  };

  const handleFocusNextItem = () => {
    setTimeout(() => {
      const lastItemIndex = itemsdetails.length - 1;

      if (itemInpRefs.current.length) {
        const nextItemIndex = lastItemIndex + 1;

        if (nextItemIndex < itemInpRefs.current.length) {
          const nextItemRef = itemInpRefs.current[nextItemIndex];

          if (nextItemRef) {
            nextItemRef.focus();
            setFocusedItemIndex(nextItemIndex);
            setShowItemSearch(true);
          }
        }
      }
    }, 0);
  };

  const handleAddClick = () => {
    const errors = [];
    if (itemsdetails)
      itemsdetails.forEach((item) => {
        if (item.itemNo === "") {
          errors.push(`Item Number cannot be empty`);
        }
        if (item.qty === "") {
          errors.push(`Item Quantity cannot be empty`);
        }
      });

    if (errors.length > 0) {
      show(errors.join(" "), "warning");
    } else {
      setItemsdetails([
        ...itemsdetails,
        {
          itemNo: "",
          product_name: "",
          collection_name: "",
          warehouse: "",
          qty: "",
          dp: "",
          unit: "",
          amount: "",
          totalQty: "",
          desc: "",
          descKey: "",
        },
      ]);
      if (scroll_wrapper_ref.current) {
        setTimeout(() => {
          const container = scroll_wrapper_ref.current;
          const scrollAmount = container.scrollTop + 100;
          container.scrollTo({ top: scrollAmount, behavior: "smooth" });
        }, 100);
      }
      handleFocusNextItem();
    }
  };

  const handleRemoveClick = (index) => {
    if (itemsdetails.length > 1) {
      const list = [...itemsdetails];
      list.splice(index, 1);
      setItemsdetails(list);
    }
  };

  const handleSelectItem = (item, index) => {
    setTimeout(() => {
      setItemsdetails((prevState) => {
        const updatedItems = prevState.map((currentItem, idx) => {
          return idx === index
            ? {
                ...currentItem,
                ...item,
                rate: item.rate ?? currentItem.rate,
              }
            : currentItem;
        });
        return updatedItems;
      });
    }, 0);
  };

  const handleItemInputFocus = (index) => {
    setFocusedItemIndex(index);
    setShowItemSearch(true);
  };

  const handleItemInputBlur = () => {
    setTimeout(() => {
      setShowItemSearch(false);
      setFocusedItemIndex(null);
    }, 200);
  };

  const handleOpenModal = (content) => {
    setIsModalOpen(true);
    setModalContent(content);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setModalContent(null);
  };

  const verifyEntries = () => {
    const warnings = [];
    if (
      (generalInfo.fromWarehouse === undefined || !generalInfo.fromWarehouse) &&
      (generalInfo.toWarehouse === undefined || !generalInfo.toWarehouse)
    ) {
      warnings.push("Warehouse is required!");
    }
    if (
      itemsdetails.every(
        (item) =>
          item.amount === "" &&
          item.price === "" &&
          item.unit === "" &&
          item.qty === "" &&
          item.itemNo === ""
      ) ||
      itemsdetails.some((item) =>
        Object.values(item).every((value) => value === "")
      )
    ) {
      warnings.push("Item Details are required");
    }
    if (warnings.length === 0) {
      return true;
    } else {
      show(warnings.join(" "), "warning");
      return false;
    }
  };

  const handleSubmit = () => {
    handleOpenModal(
      <ManagerModal
        heading={"Confirm Order"}
        centerHeading={"Are you sure want to place this Order?"}
        targetWord={"order"}
        handleCloseModal={() => handleCloseModal()}
        handleSubmit={() => handleTransferOrder("New Order")}
      />
    );
  };

  useEffect(() => {
    onOrderData({
      loading,
      status: generalInfo.status,
      orderId: orderId,
      orderDate: generalInfo.voucherDate,
    });
  }, [
    generalInfo.status,
    generalInfo.voucherDate,
    loading,
    onOrderData,
    orderId,
  ]);

  let cartPriceSum =
    itemsdetails &&
    itemsdetails.reduce((sum, currentItem) => {
      return (
        sum +
        parseFloat(currentItem.price ? currentItem.price : 0) *
          parseFloat(currentItem.qty ? currentItem.qty : 0)
      );
    }, 0);

  let subtotal = cartPriceSum ? cartPriceSum : 0;

  let totalAmount =
    subtotal +
    parseFloat(generalInfo.shippingCharge ? generalInfo.shippingCharge : 0) +
    parseFloat(generalInfo.manageValue ? generalInfo.manageValue : 0);

  const transferHeader = [
    "S.No",
    "Item No",
    "Product",
    "Quantity",
    "Unit",
    "Rate",
    "Amount",
  ];

  return (
    <>
      <ModalWrapper isOpen={isModalOpen} onClose={handleCloseModal} noBtn>
        {modalContent}
      </ModalWrapper>

      <div className={styles.scroll_wrapper} ref={scroll_wrapper_ref}>
        <form className={styles.t_form}>
          {(loading && orderId) || loading2 ? (
            <div>
              <Skeleton
                lines={1}
                thickness={4.5}
                additionalStyles={{
                  marginBottom: "0px",
                  marginTop: "20px",
                }}
              />
            </div>
          ) : (
            <div style={{ width: "33%" }}>
              <VerticalDropDown2
                height={"37px"}
                fontSize={"12px"}
                dropDownText={"Auto"}
                label={"From Warehouse"}
                value={{
                  label:
                    warehouses?.find(
                      (w) => w.warehouseId === generalInfo.fromWarehouse
                    )?.warehousename || "Select",
                  value: generalInfo.fromWarehouse,
                }}
                options={
                  warehouses &&
                  warehouses
                    .filter((w) => w.warehouseId !== generalInfo.toWarehouse)
                    .map((w) => ({
                      label: w.warehousename,
                      value: w.warehouseId,
                    }))
                }
                onchange={(option) => {
                  setGeneralInfo((prevState) => ({
                    ...prevState,
                    fromWarehouse: option.value,
                  }));
                  setOpenDD2(true);
                }}
                dropDownOpen={!orderId && true}
                disableOpen={orderId}
              />
            </div>
          )}

          {(loading && orderId) || loading2 ? (
            <div>
              <Skeleton
                lines={1}
                thickness={4.5}
                additionalStyles={{
                  marginBottom: "0px",
                  marginTop: "20px",
                }}
              />
            </div>
          ) : (
            <div style={{ width: "33%" }}>
              <VerticalDropDown2
                height={"37px"}
                fontSize={"12px"}
                dropDownText={"Auto"}
                label={"To Warehouse"}
                value={{
                  label:
                    warehouses?.find(
                      (w) => w.warehouseId === generalInfo.toWarehouse
                    )?.warehousename || "Select",
                  value: generalInfo.toWarehouse,
                }}
                options={
                  warehouses &&
                  warehouses
                    .filter((w) => w.warehouseId !== generalInfo.fromWarehouse)
                    .map((w) => ({
                      label: w.warehousename,
                      value: w.warehouseId,
                    }))
                }
                onchange={(option) => {
                  setGeneralInfo((prevState) => ({
                    ...prevState,
                    toWarehouse: option.value,
                  }));
                  itemInpRefs.current[0]?.focus();
                }}
                dropDownOpen={orderId ? false : openDD2}
                disableOpen={orderId}
              />
            </div>
          )}

          {(loading && orderId) || loading2 ? (
            <div>
              <Skeleton
                lines={1}
                thickness={4.5}
                additionalStyles={{
                  marginBottom: "0px",
                  marginTop: "20px",
                }}
              />
            </div>
          ) : (
            <div style={{ width: "33%" }}>
              <InputTag
                labelText={"Manager Name"}
                value={orderId ? generalInfo.managerName : managerName}
                padding={"8px"}
                fontSize={"12px"}
                required
                readOnly={true}
              />
            </div>
          )}
        </form>

        <ul className={styles.p_table}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              visibility: loading && "hidden",
            }}
          >
            <li
              className={`${styles.p_table_header} ${
                mode ? styles.p_table_header_dark : ""
              }`}
            >
              {transferHeader.map((h, index) => (
                <div
                  className={`${styles.entry_2} ${
                    h === "Item No" && !orderId ? styles.item_no : ""
                  }`}
                  key={`${h}-${index}`}
                >
                  {h}
                </div>
              ))}
            </li>
            {!orderId && itemsdetails.length > 1 && (
              <div style={{ cursor: "pointer", visibility: "hidden" }}>
                <RemoveIcon />
              </div>
            )}
          </div>
          <div className={styles.p_table_list}>
            <>
              {itemsdetails.map((item, index) => (
                <React.Fragment key={index}>
                  {orderId ? (
                    <>
                      {(loading && orderId) || loading2 ? (
                        <div>
                          <Skeleton
                            lines={
                              itemsdetails.length === 1
                                ? 1
                                : itemsdetails.length / 2
                            }
                            thickness={5}
                            additionalStyles={{
                              marginBottom: "0px",
                              marginTop: "0px",
                            }}
                          />
                        </div>
                      ) : (
                        <PurchaseItemList
                          index={index}
                          mode={mode}
                          item={item}
                        />
                      )}
                    </>
                  ) : (
                    <PurchaseNewItemList
                      index={index}
                      mode={mode}
                      item={item}
                      managerId={managerId}
                      itemInpRefs={(el) => (itemInpRefs.current[index] = el)}
                      itemsdetailslength={itemsdetails.length}
                      onSelectItem={(item) => {
                        handleSelectItem(item, index);
                      }}
                      addItem={() => handleAddClick()}
                      removeItem={() => handleRemoveClick(index)}
                      showItemSearch={
                        showItemSearch && focusedItemIndex === index
                      }
                      setShowItemSearch={setShowItemSearch}
                      focusedIndex={focusedItemIndex}
                      onFocus={() => handleItemInputFocus(index)}
                      onBlur={handleItemInputBlur}
                      onCompletion={() => handleSubmit()}
                      warehouse_id={generalInfo.fromWarehouse}
                      type={"Transfer"}
                      quantityRefs={quantityRefs.current}
                    />
                  )}
                </React.Fragment>
              ))}
            </>
          </div>
          {!orderId && (
            <div
              className={styles.cricle_btn}
              onClick={() => {
                handleAddClick();
              }}
            >
              <TestTopAddDealerIcon color="#4164E3" />
            </div>
          )}
        </ul>
        {/* </>
        )} */}
      </div>

      {(loading && orderId) || loading2 ? (
        <div
          style={{ padding: "0", boxShadow: "none" }}
          className={`${styles.footer} ${mode ? styles.footer_dark : ""}`}
        >
          <Skeleton
            lines={1}
            thickness={5}
            additionalStyles={{
              marginBottom: "0px",
              marginTop: "0px",
              borderRadius: "15px 15px 0 0",
            }}
          />
        </div>
      ) : (
        <div className={`${styles.footer} ${mode ? styles.footer_dark : ""}`}>
          <div className={styles.footer_right}>
            {orderId ? (
              <div>
                <Button
                  buttonIcon={<NewEyeIcon />}
                  buttonText={"View Invoice"}
                  buttonBgColor={"#000000"}
                  buttonTextColor={"#ffffff"}
                  buttonBorder={"none"}
                  // buttonClick={() =>
                  //   navigate("/orders/purchaseinvoice/" + orderId)
                  // }
                />
              </div>
            ) : (
              <div>
                <Button
                  buttonIcon={<SaveAsDraftIcon />}
                  buttonText={"Save as Draft"}
                  buttonBgColor={"#000000"}
                  buttonTextColor={"#ffffff"}
                  buttonBorder={"none"}
                />
              </div>
            )}
            <div
              className={`${styles.footer_right_1} ${
                mode ? styles.footer_right_1_dark : ""
              }`}
            >
              <div>
                <p>Sub Total:</p>
                <p>₹ {subtotal}</p>
              </div>
              <div>
                <p>Shipping Charges:</p>
                <p>
                  ₹{" "}
                  {generalInfo.shippingCharge ? generalInfo.shippingCharge : 0}
                </p>
              </div>
              <div>
                <p>Total Amount(INR):</p>
                <p>₹ {totalAmount}</p>
              </div>
            </div>
            {!orderId && (
              <div className={styles.footer_right_2}>
                <Button
                  buttonIcon={<SaveIcon />}
                  buttonText={"Save"}
                  buttonBgColor={"#4164E3"}
                  buttonTextColor={"#FFFFFF"}
                  buttonBorder={"none"}
                  buttonClick={() => {
                    if (verifyEntries()) {
                      handleSubmit();
                    }
                  }}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Transfer;
